import React from 'react';
import AuthContainer from './AuthContainer';


export default wrappedComponent => props => (
  <AuthContainer
    component={wrappedComponent}
    {...props}
  />
);
